/** Actividad del usuario para la sesión por inactividad (de SGDEA): la web informa cuántos segundos lleva sin usarla. */
let last = Date.now();
export const markActivity = () => {
  last = Date.now();
};
export const idleSeconds = () => Math.floor((Date.now() - last) / 1000);
export function startActivityTracking() {
  const events = ['pointerdown', 'keydown', 'wheel', 'touchstart'];
  events.forEach((e) => window.addEventListener(e, markActivity, { passive: true }));
  return () => events.forEach((e) => window.removeEventListener(e, markActivity));
}
